import expert from './expert';
import prompts from './prompts';
import dossier from './dossier';
import hrprojects from './hrprojects';

export default {
  namespaced: true,
  modules: {
    expert,
    prompts,
    dossier,
    hrprojects,
  },
};
